export * from './ingredient-icons.data';